// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"10cbae13","366":"8c691e88","501":"859f08d3","595":"828c4290"}[chunkId] + ".chunk.js";
};